/* =========================================
   TRANSLATIONS
========================================= */
export const translations = {
  en: {
    navHome: "Home",
    navShop: "Shop",
    cart: "Cart",
    heroEyebrow: "Luxury Fragrance Curation",
    heroTitleLine1: "Desire begins",
    heroTitleLine2: "in the dark.",
    heroText:
      "Discover designer, niche and Arabian fragrances through a premium decant experience. Test on skin. Wear with intent. Own the moment.",
    heroNow: "Now €39.50",
    heroOffer: "Afnan 9PM Rebel 100ml full bottle",
    exploreCollection: "Explore Collection",
    claimOffer: "Claim the Offer",
    valueTry: "✔ Try before you buy",
    valuePremium: "✔ Only premium fragrances",
    valueDelivery: "✔ Delivery across Montenegro",
    highlightsKicker: "Current Highlights",
    highlightsTitle: "Selected for impact",
    highlightsText:
      "Curated bottles and standout decants chosen for performance, compliment factor and identity.",
    campaignPick: "Campaign Pick",
    summerHit: "Summer Hit",
    arabianEdge: "Arabian Edge",
    rebelCardText:
      "A bold full-bottle offer with serious value. The current hero of the season.",
    islandDreamsText:
      "Bright, addictive and made for warm weather. Easy reach, high reward.",
    marwaText:
      "Smooth character, strong identity and standout value in decant format.",
    add100ml: "Add 100ml for €39.50",
    privateSelection: "Private Selection",
    bestsellersTitle: "Bestsellers that leave a mark.",
    bestsellersText:
      "The most wanted PlayNice decants and signature picks — for those who want a scent people remember.",
    viewFullCollection: "View Full Collection",
    discoverTitle: "Discover Your Signature",
    discoverText: "Test before you commit. Find what truly fits you.",
    shopKicker: "Shop",
    shopTitle: "PlayNice Collection",
    shopText:
      "Premium decants and selected bottles. Built for discovery, style and smart buying.",
    searchLabel: "Search",
    searchPlaceholder: "Search fragrance...",
    categoryLabel: "Category",
    all: "All",
    from: "Starting at",
    openDetails: "Open details",
    luxuryModal: "Luxury modal",
    yourCart: "Your Cart",
    selectedItems: "Selected items",
    cartEmpty: "Your cart is empty.",
    goToShop: "Go to Shop",
    subtotal: "Subtotal",
    shipping: "Shipping",
    freeShippingNote: "Free shipping over €49",
    freeShippingUnlocked: "Free shipping unlocked",
    freeShippingLeft: "left to free shipping",
    freeShippingProgress: "You’re {{amount}} away from free shipping",
    total: "Total",
    continueCheckout: "Continue to Checkout",
    checkoutKicker: "Checkout",
    checkoutTitle: "Complete your order",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    city: "City",
    address: "Address",
    note: "Order note (optional)",
    placeOrder: "Place Order",
    placingOrder: "Placing order...",
    orderSuccess: "Order sent successfully.",
    orderError: "There was an error sending your order. Please try again.",
    fillRequired: "Please fill in all required fields.",
    emptyCartAlert: "Your cart is empty.",
    orderSummary: "Order summary",
    noItemsCart: "No items in cart.",
    privateDetailModal: "Private Detail",
    whyChoose: "Why customers choose this",
    whyChooseText:
      "Strong identity, premium feel and excellent value in decant format.",
    chooseSize: "Choose size",
    selectedPrice: "Selected price",
    addToCart: "Add to Cart",
    modalNote:
      "Try before you buy. Premium fragrance discovery, delivered across Montenegro.",
    page: "Page",
    remove: "Remove",
    addedToCart: "added to cart",
    justAdded: "Added ✓",
    announcement1: "Free shipping over €49",
    announcement2: "Try before you buy — 2ml, 5ml, 10ml & 20ml decants",
    announcement3: "Premium niche, designer & arabic fragrances",
    announcement4: "Limited stock drops — don’t miss out",
    announcement5: "Delivery across Montenegro",
    announcement6: "✔ 500+ satisfied customers",
    announcementDynamicLocked: "Add {{amount}} more to unlock free shipping",
    announcementDynamicUnlocked: "Free shipping unlocked ✓",
    announcementDynamicEmpty1: "Free shipping over €49",
    announcementDynamicEmpty2:
      "Try before you buy — 2ml, 5ml, 10ml & 20ml decants",
    announcementDynamicEmpty3: "Premium niche, designer & arabic fragrances",
    announcementDynamicEmpty4: "Limited stock drops — don’t miss out",
    announcementDynamicEmpty5: "Delivery across Montenegro",
    announcementDynamicEmpty6: "✔ 500+ satisfied customers",
    navStory: "Story",
    heroCampaigns: [
      {
        id: "9pm",
        eyebrow: "NEW NIGHT DROP",
        title1: "9PM Night Out",
        title2: "was made to be tried.",
        text:
          "New from Afnan. Dark, modern and made for nights that leave an impression.",
        cta: "TRY BEFORE YOU BUY",
        sub: "Available in 5ml, 10ml and 20ml decants"
      }
    ],
    sortLabel: "Sort by",
    sortFeatured: "Featured",
    sortRating: "Top Rated",
    sortPriceLow: "Price: Low to High",
    sortPriceHigh: "Price: High to Low",
    sortName: "A–Z",
    seasonLabel: "Season",
    seasonAll: "All",
    seasonSummer: "Spring / Summer",
    seasonWinter: "Fall / Winter",
    stickyExplore: "Explore Collection",
    stickySaved: "Open Private Selection",
    stickyCart: "Open Cart",
    stickyCheckout: "Checkout",
    stickyItems: "items",
    stickyItem: "item",
    checkoutCodInfo: "Cash on delivery — order confirmation and details will be sent by email.",
    checkoutTrust1: "Cash on delivery — you pay only when your order arrives",
    checkoutTrust2: "Order confirmation and all details will be sent by email",
    checkoutTrust3: "100% original fragrances and premium decants",
    checkoutTrust4: "Delivery across Montenegro",
    checkoutSafeNote: "No online payment — after placing your order, you will receive confirmation and all details by email.",
    checkoutSummaryTrust: "Cash on delivery • Original fragrances • Delivery in Montenegro",
    checkoutSubmitCod: "Order — pay on delivery",
    // CART
    continueCheckout: "Continue to delivery details",
    cartSafeNote: "No online payment — you pay only on delivery",
    cartTrust1: "Cash on delivery",
    cartTrust2: "Confirmation and details sent by email",
    cartTrust3: "Delivery across Montenegro",

    // SHIPPING
    freeShippingSoft: "{{amount}} away from free shipping",

    // CHECKOUT
    checkoutSubmitCod: "Order — pay on delivery",
    checkoutCodInfo: "Cash on delivery — order confirmation and details will be sent by email.",
    checkoutSafeNote: "No online payment — after placing your order, you will receive confirmation and all details by email.",

    // CHECKOUT TRUST
    checkoutTrust1: "Cash on delivery — you pay only when your order arrives",
    checkoutTrust2: "Order confirmation and all details will be sent by email",
    checkoutTrust3: "100% original fragrances and premium decants",
    checkoutTrust4: "Delivery across Montenegro",

    // PRODUCT CARD
    tryFrom: "From",
    productDecantNote: "Wear it first. Decide later.",
    productCardCta: "Start with 5ml →",

    sizeBestChoice: "Best pick",

    wearHint_2ml: "1–3 wears",
    wearHint_5ml: "5–7 wears",
    wearHint_10ml: "10–14 wears",
    wearHint_20ml: "20+ wears",

    journalKicker: "So what’s new?",
    journalTitle: "Le Journal",
    journalSubtitle:
     "Stories, updates, little chaos and big scents — from the point of view of a house that lives fragrance every day.",
    journalReadArticle: "Read article",
    journalReadingTime: "2 min read",
    journalAuthorName: "Charlie",
    journalAuthorRole: "PlayNice Editorial",
    journalClose: "Close Le Journal",
    journalCloseArticle: "Close article",
    justIn: "JUST IN",
    heroYslCta: "CLAIM THE DROP",
  },

  sr: {
    navHome: "Početna",
    navShop: "Shop",
    cart: "Korpa",
    heroEyebrow: "Luksuzna selekcija parfema",
    heroTitleLine1: "Želja počinje",
    heroTitleLine2: "u tami.",
    heroText:
      "Otkrij dizajnerske, niche i arapske parfeme kroz premium decant iskustvo. Isprobaj na koži. Nosi sa stavom. Osvoji trenutak.",
    heroNow: "Sada €39.50",
    heroOffer: "Afnan 9PM Rebel 100ml puna bočica",
    exploreCollection: "Pogledaj kolekciju",
    claimOffer: "Uzmi ponudu",
    valueTry: "✔ Probaj pre kupovine",
    valuePremium: "✔ Samo premium parfemi",
    valueDelivery: "✔ Dostava širom Crne Gore",
    highlightsKicker: "Aktuelno izdvojeno",
    highlightsTitle: "Odabrano da ostavi utisak",
    highlightsText:
      "Pažljivo odabrane bočice i dekanti koji se izdvajaju performansama, komplimentima i karakterom.",
    campaignPick: "Glavna ponuda",
    summerHit: "Letnji hit",
    arabianEdge: "Arapski karakter",
    rebelCardText:
      "Moćna full bottle ponuda sa ozbiljnom vrednošću. Trenutni heroj sezone.",
    islandDreamsText:
      "Svetao, zarazan i stvoren za toplo vreme. Lak izbor, jak efekat.",
    marwaText:
      "Uglađen karakter, snažan identitet i odlična vrednost u decant formatu.",
    add100ml: "Dodaj 100ml za €39.50",
    privateSelection: "Private Selection",
    bestsellersTitle: "Bestseleri koji ostavljaju trag.",
    bestsellersText:
      "Najtraženiji PlayNice dekanti i signature izbori — za one koji žele miris po kojem će ih pamtiti.",
    viewFullCollection: "Pogledaj celu kolekciju",
    discoverTitle: "Pronađi svoj signature miris",
    discoverText:
      "Isprobaj pre odluke. Pronađi ono što ti zaista pristaje.",
    shopKicker: "Shop",
    shopTitle: "PlayNice kolekcija",
    shopText:
      "Premium dekanti i pažljivo odabrane bočice. Stvoreno za otkrivanje, stil i pametnu kupovinu.",
    searchLabel: "Pretraga",
    searchPlaceholder: "Pretraži parfem...",
    categoryLabel: "Kategorija",
    all: "Sve",
    from: "Već od",
    openDetails: "Otvori detalje",
    luxuryModal: "Premium prikaz",
    yourCart: "Tvoja korpa",
    selectedItems: "Odabrani proizvodi",
    cartEmpty: "Tvoja korpa je trenutno prazna.",
    goToShop: "Idi na shop",
    subtotal: "Međuzbir",
    shipping: "Dostava",
    freeShippingNote: "Besplatna dostava preko 49€",
    freeShippingUnlocked: "Besplatna dostava otključana",
    freeShippingLeft: "do besplatne dostave",
    freeShippingProgress:
      "Nedostaje ti {{amount}} do besplatne dostave",
    total: "Ukupno",
    continueCheckout: "Nastavi ka porudžbini",
    checkoutKicker: "Poručivanje",
    checkoutTitle: "Još samo korak do tvoje porudžbine",
    firstName: "Ime",
    lastName: "Prezime",
    email: "Email adresa",
    phone: "Broj telefona",
    city: "Grad",
    address: "Adresa",
    note: "Napomena uz porudžbinu (opciono)",
    placeOrder: "Potvrdi i pošalji porudžbinu",
    placingOrder: "Šalje se porudžbina...",
    orderSuccess: "Porudžbina je uspešno poslata.",
    orderError:
      "Došlo je do greške pri slanju porudžbine. Pokušaj ponovo.",
    fillRequired: "Molimo popuni sva obavezna polja.",
    emptyCartAlert: "Korpa je prazna.",
    orderSummary: "Pregled porudžbine",
    noItemsCart: "Nema proizvoda u korpi.",
    privateDetailModal: "Detalji parfema",
    whyChoose: "Zašto kupci biraju ovaj parfem",
    whyChooseText:
      "Jak identitet, premium utisak i odlična vrednost u decant formatu.",
    chooseSize: "Izaberi veličinu",
    selectedPrice: "Izabrana cena",
    addToCart: "Dodaj u korpu",
    modalNote:
      "Probaj pre kupovine. Otkrij premium parfeme uz dostavu širom Crne Gore.",
    page: "Strana",
    remove: "Ukloni",
    addedToCart: "je dodat u korpu",
    justAdded: "Dodato ✓",
    announcement1: "Besplatna dostava preko 49€",
    announcement2:
      "Probaj pre kupovine — 2ml, 5ml, 10ml & 20ml dekanti",
    announcement3: "Premium niche, dizajnerski & arapski parfemi",
    announcement4: "Ograničene količine — ne propusti",
    announcement5: "Dostava širom Crne Gore",
    announcement6: "✔ 500+ zadovoljnih kupaca",
    announcementDynamicLocked:
      "Dodaj još {{amount}} za besplatnu dostavu",
    announcementDynamicUnlocked: "Besplatna dostava otključana ✓",
    announcementDynamicEmpty1: "Besplatna dostava preko 49€",
    announcementDynamicEmpty2:
      "Probaj pre kupovine — 2ml, 5ml, 10ml i 20ml dekanti",
    announcementDynamicEmpty3:
      "Premium niche, dizajnerski i arapski parfemi",
    announcementDynamicEmpty4: "Ograničene količine — ne propusti",
    announcementDynamicEmpty5: "Dostava širom Crne Gore",
    announcementDynamicEmpty6: "✔ 500+ zadovoljnih kupaca",
    navStory: "Priča",
    heroCampaigns: [
      {
        id: "9pm",
        eyebrow: "NOVI NOĆNI DROP",
        title1: "9PM Night Out",
        title2: "stvoren da se doživi.",
        text:
          "Novo iz Afnan kolekcije. Tamno, moderno i stvoreno za noći koje ostavljaju utisak.",
        cta: "ISPROBAJ PRE KUPOVINE",
        sub: "Dostupno u 5ml, 10ml i 20ml dekantima"
      }
    ],
    sortLabel: "Sortiranje",
    sortFeatured: "Preporučeno",
    sortRating: "Najbolje ocenjeni",
    sortPriceLow: "Cena: niža → viša",
    sortPriceHigh: "Cena: viša → niža",
    sortName: "A–Š",
    seasonLabel: "Sezona",
    seasonAll: "Sve",
    seasonSummer: "Proleće / Leto",
    seasonWinter: "Jesen / Zima",
    stickyExplore: "Istraži kolekciju",
    stickySaved: "Otvori Private Selection",
    stickyCart: "Otvori korpu",
    stickyCheckout: "Nastavi porudžbinu",
    stickyItems: "artikala",
    stickyItem: "artikal",
    checkoutCodInfo: "Plaćanje pouzećem — potvrda narudžbine i detalji stižu na email.",
    checkoutTrust1: "Plaćanje pouzećem — plaćate tek kada pošiljka stigne",
    checkoutTrust2: "Potvrda narudžbine i svi detalji stižu na email",
    checkoutTrust3: "100% original parfemi i premium dekanti",
    checkoutTrust4: "Dostava širom Crne Gore",
    checkoutSafeNote: "Bez online plaćanja — nakon narudžbine dobijate potvrdu i sve informacije na email.",
    checkoutSummaryTrust: "Plaćanje pouzećem • Original parfemi • Dostava u Crnoj Gori",
    checkoutSubmitCod: "Naruči — plaćanje pouzećem",
    // CART
    continueCheckout: "Dalje do podataka za dostavu",
    cartSafeNote: "Bez online plaćanja — plaćate tek pri preuzimanju",
    cartTrust1: "Plaćanje pouzećem",
    cartTrust2: "Potvrda i detalji stižu na email",
    cartTrust3: "Dostava širom Crne Gore",

    // SHIPPING
    freeShippingSoft: "Još {{amount}} do besplatne dostave",

    // CHECKOUT
    checkoutSubmitCod: "Naruči — plaćanje pouzećem",
    checkoutCodInfo: "Plaćanje pouzećem — potvrda narudžbine i detalji stižu na email.",
    checkoutSafeNote: "Bez online plaćanja — nakon narudžbine dobijate potvrdu i sve informacije na email.",

    // CHECKOUT TRUST
    checkoutTrust1: "Plaćanje pouzećem — plaćate tek kada pošiljka stigne",
    checkoutTrust2: "Potvrda narudžbine i svi detalji stižu na email",
    checkoutTrust3: "100% original parfemi i premium dekanti",
    checkoutTrust4: "Dostava širom Crne Gore",

    // PRODUCT CARD
    tryFrom: "Već od",
    productDecantNote: "Nosi ga prvo. Odluči kasnije.",
    productCardCta: "Kreni sa 5ml →",

    sizeBestChoice: "Preporuka",

    wearHint_2ml: "1–3 nošenja",
    wearHint_5ml: "5–7 nošenja",
    wearHint_10ml: "10–14 nošenja",
    wearHint_20ml: "20+ nošenja",

    journalKicker: "Šta je novo?",
    journalTitle: "Le Journal",
    journalSubtitle:
      "Priče, noviteti, mali haosi i veliki mirisi — iz ugla kuće koja živi parfeme svaki dan.",
    journalReadArticle: "Pročitaj članak",
    journalReadingTime: "2 min čitanja",
    journalAuthorName: "Čarli",
    journalAuthorRole: "PlayNice Editorial",
    journalClose: "Zatvori Le Journal",
    journalCloseArticle: "Zatvori članak",
    justIn: "NOVO",
    heroYslCta: "OSVOJI DROP",
  }
};